import * as React from "react";
import { LazyImage } from "@grandvisionhq/common";
import { FacetLink } from "./FacetLink.js";
import { useAccessibleName } from "../../../../../hooks/modules/EcommContent/components/FacetPickers/components/hooks/useAccessibleName.js";
const FacetWithImage = ({ item, isActive, onPick, productType }) => {
  const accessibleName = useAccessibleName(item);
  return /* @__PURE__ */ React.createElement(
    FacetLink,
    {
      item,
      isActive,
      onPick,
      productType,
      accessibleName
    },
    item.imageUrl && /* @__PURE__ */ React.createElement(
      LazyImage,
      {
        className: "facet-picker__image",
        src: item.imageUrl,
        alt: accessibleName,
        width: 64,
        height: 32
      }
    )
  );
};
export {
  FacetWithImage
};
//# sourceMappingURL=FacetWithImage.js.map
